import { useState } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';


const ModalHelpStyles = styled.div`
height: auto;
width: 100%;
h2 {
    font-size: 22px;
    margin: 0 0 14px;
}
h3 {
    font-size: 16px;
    margin: 10px 0 2px;
}
.bordered {
    border: 3px solid #E0004D;
    border-radius: 6px;
    padding: 0 5px;
    display: inline-block;
    margin-left: -5px;
}
.subTittle {
    font-size: 18px;
}

`;


const CloseModal = styled.button`
background: #fff;
border: 2px solid black;
border-radius: 50px;
color: #221c35;
cursor: pointer;
font-weight: 800;
font-size: 15px;
position: absolute;
width: 25px;
padding: 0;
top: 16px;
right: 22px;
`;

const HelpIcon = styled.div`
font-weight: 800;
width: 28px;
min-width: 17px;
height: 16px;
font-size: 16px;
border: 2px solid #221c35;
border-radius: 50px;
line-height: 1;
padding: 0;
margin-top: 2px;
`;


export const ModalHelp = () => {
 
    const [modalIsOpen, setIsOpen] = useState(false);
    const toggleModal = () => setIsOpen(!modalIsOpen);
   

    const modalStyles = {
        content: {
          top: '40%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          padding: '50px 25px 35px 30px',
          width: '80%',
          maxWidth: '370px',
          transform: 'translate(-50%, -50%)',
        },
        overlay: {
            backgroundColor: '#00000080'
          }
        };
    
  return (
    <>

    <HelpIcon onClick={toggleModal} style={{cursor: 'pointer'}}>?</HelpIcon>

        <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={toggleModal} style={modalStyles}>
            <ModalHelpStyles>
                <CloseModal onClick={toggleModal} >X</CloseModal>
                    <h2><b>Revisa el mail de confirmación de compra</b></h2>
                    <p className='subTittle'>Si compraste con boleta:</p>
                    <h3><strong>INFORMACIÓN DE ORDEN DE COMPRA</strong></h3>

                    <p><b>Número de orden:</b> 13907471</p>  
                    <p className='bordered'><b>Número de boleta:</b> 61457766</p>  
                    <p><b>Fecha de la compra:</b> agosto 09, 2020</p> 
                    <br /> 

                    <p className='subTittle'>Si compraste con factura:</p>
                    <h3><strong>INFORMACIÓN DE ORDEN DE COMPRA</strong></h3>
                    <p><b>Número de orden:</b> 13907471</p>  
                    <p className='bordered'><b>Número de factura:</b> 61457867</p>  
                    <p><b>Fecha de la compra:</b> agosto 09, 2020</p> 

            </ModalHelpStyles>
        </Modal>

  </>
  );
}
